import { translator } from "../../../translation/translator";
import { CategoryHierarchyTreeUtils } from "../../../search/category/hierarchy/category-hierarchy-tree-utils";
import { SearchCategoryModalSetup } from "../../../search/category/modal/search-category-modal-setup";
import { ChipPickerHandler } from "../chips/chip-picker-handler";
import { ChipPickerListener } from "../chips/chip-picker-listener";
import { SearchCategoryPickerForm } from "./search-category-picker-form";

function createCategoryNameMap(): Map<string, string> {
    return new Map();
}

export interface SearchCategoryPickerSetupParams {
    menuRoot: HTMLElement;
    apiData: unknown;
    initialSelectedIds: string[];
    onSelectionChange: (ids: string[]) => void;
}

export class SearchCategoryPickerSetup {
    public static setupForSearchMenu(params: SearchCategoryPickerSetupParams): ChipPickerHandler | null {
        const { menuRoot, apiData, initialSelectedIds, onSelectionChange } = params;

        const pickerRoot = SearchCategoryPickerForm.getPickerRoot(menuRoot);
        const chipsEl = SearchCategoryPickerForm.getChips(menuRoot);

        if (!(pickerRoot instanceof HTMLElement) || !(chipsEl instanceof HTMLElement)) {
            return null;
        }

        const modal = SearchCategoryModalSetup.init(document);
        if (!modal) return null;

        const tree = CategoryHierarchyTreeUtils.fromApiData(apiData);
        const nameById = createCategoryNameMap();
        tree.parents.forEach((parent) => nameById.set(String(parent.id), String(parent.name || parent.id)));
        tree.childrenByParentId.forEach((children) => {
            children.forEach((child) => nameById.set(String(child.id), String(child.name || child.id)));
        });

        modal.setApiData(apiData);
        modal.setSelectedIds(initialSelectedIds);

        const controller = new ChipPickerHandler({
            chipsEl,
            openBtnEl: pickerRoot,
            idAttribute: "data-category-id",
            removeAction: "remove",
            renderOptions: {
                chipClass: "picker-chip",
                labelClass: "picker-chip__label",
                removeClass: "picker-chip__remove",
                removeAriaLabel: "Remove",
                emptyHtml:
                    '<span class="input-placeholder search-item" data-translate="select_category">Select category</span>',
            },
        });

        controller.setLabelMap(nameById);
        controller.setSelectedIds(initialSelectedIds);
        controller.setOnSelectionChange(onSelectionChange);
        controller.setExternalSelectionUI({
            setSelectedIds: (ids: string[]) => modal.setSelectedIds(ids),
            setOnSelectionChange: (callback: (ids: string[]) => void) => modal.setOnSelectionChange(callback),
            open: () => modal.open(),
        });
        controller.render();
        translator.updateUITranslations();

        ChipPickerListener.setup({
            rootEl: pickerRoot,
            scopeKey: "search-category-picker",
            openBtnEl: pickerRoot,
            chipsEl,
            controller,
        });

        return controller;
    }
}
